'use client';

import { Suspense, useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { sendGAEvent } from '@next/third-parties/google';

const GA_ID = process.env.NEXT_PUBLIC_GA4_ID?.trim();

/**
 * GA4 page views on soft navigation. The initial page view is sent by
 * {@link GoogleAnalytics} `gtag('config')`; subsequent routes use `config` updates.
 */
function GaPageViewsInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  const skipNextConfig = useRef(true);

  useEffect(() => {
    if (!GA_ID) return;
    const path = search ? `${pathname}?${search}` : pathname;
    if (skipNextConfig.current) {
      skipNextConfig.current = false;
      return;
    }
    sendGAEvent('config', GA_ID, { page_path: path });
  }, [pathname, search]);

  return null;
}

export function GaPageViews() {
  if (!GA_ID) return null;
  return (
    <Suspense fallback={null}>
      <GaPageViewsInner />
    </Suspense>
  );
}
